import React, { useContext, useState, useEffect, useRef } from 'react';
import forgeticon from '../../../Assets/Images/catchforgetIcon.png'
import { FormNewPassword, LangContext } from '../../../App'
import { Modal, Row, } from 'react-bootstrap'
import './ForgetPassword.css'
import { useForm } from "react-hook-form";
import { API_ENDPOINT } from '../../../AppConfig';
import axios from 'axios';
import NewPassword from './NewPassword'
import PinInput from "react-pin-input";
import string from '../../../Assets/Localization/Local'
import Empty from 'antd/es/empty';

function useInterval(callback, delay) {
  const savedCallback = useRef();


  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

const ConfirmCode = (props) => {

  const { lang } = useContext(LangContext)
  const [data, setData] = useState();
  const [show, setShow] = useState(true);
  // const [code, setCode] = useState()
  // const [errormsg, setError] = useState(false)
  const [count, setCount] = useState(0);
  const [ErrorFlag,setErrorFlag]= useState(false)
  const [variable, setVariable] = useState("00:00");
  const { openFormNewPass, ToggleForm_newPass } = useContext(FormNewPassword)
  const { handleSubmit} = useForm({ });
  useEffect(() => {
    if (openFormNewPass === true) {
      setShow(false)
    }
  })
  // const inputStyle = {
  //   textAlign: 'center',
  //   borderBottom: '2px solid #E3E3E3',
  //   fontSize: '22px',
  //   outline: 'none'
  // }
  // const handleShow = () => setShow(true);

  const onSubmit = (data) => {
    setData(props.phone)
    console.log('confirm code ==data-> ', data,data.length,data==={},Object.keys(data).length === 0);
    let uri = `${API_ENDPOINT}/phoneConfirmationCode`;
    if (Object.keys(data).length === 0){
     setErrorFlag(true)
     return 
    }
    let submitData = {}
    submitData.phone = props.phone.phone
    submitData.code = (data.num1 === "" ? '0' : data.num1) + (data.num2 === "" ? '0' : data.num2) + (data.num3 === "" ? '0' : data.num3) + (data.num4 === "" ? '0' : data.num4)

    console.log('submitData code=> ', submitData, props)

    axios.put(uri, submitData, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      ToggleForm_newPass()
    }).catch(error => {
      ToggleForm_newPass()
    })
  }
  const onChange = value => {
    // setCode(value);
    // setError(false)
  };
  useInterval(() => {
    // Your custom logic here
    if (count !== 60) {
      let variable = count + 1 < 10 ? `00:0${count + 1}` : `00:${count + 1}`
      setCount(count + 1)
      setVariable(variable)

    }
  }, 1000);
  const sendcode = () => {
    // console.log('hello')

    let uri = `${API_ENDPOINT}/phoneForgetPassword`
    let data = {
      phone: props.phone.phone
    }

    // console.log('SendCode uri==> ', uri, data)
    axios.post(uri, data, {
      headers: {
        'Content-Type': "application/json"
      }
    }).then(response => {
      // console.log('SendCode uri==> ', response)

    }).catch(error => {
      // console.log('SendMail uri==>error ', error.response)
      // setOpen(true);
      if (!error.response) {
        // setErrorSnakbar("Network Error")
      }
      else if (error.response.status === 422) {
        for (let i = 0; i < error.response.data.errors.length; i++) {
          // setErrorSnakbar(error.response.data.errors[i].msg)
        }
      }
      else {
        // setErrorSnakbar(error.response.data.errors)
      }
    })
  }
  const resend = () => {
    sendcode()
    setCount(0)
    setVariable("00:00")
  }
  useInterval(() => {
    // Your custom logic here
    if (count !== 60) {
      let variable = count + 1 < 10 ? `00:0${count + 1}` : `00:${count + 1}`
      setCount(count + 1)
      setVariable(variable)

    }
  }, 1000);
  string.setLanguage(lang)
  return (
    <div>
      <Modal className="forgetmodal text-center" show={show} onHide={props.close} animation={false}>
        <Modal.Header className="justify-content-center pb-0">
          <h3 className="mt-3">{string.forget}</h3>
          <i style={{ left: "10px" }} onClick={props.close} className="fas fa-times close-icon"></i>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="imgforgetcontainer">
            <img src={forgeticon} alt="deleteimg" className="forgetimg" />
          </div>
          <h5>{string.sententercode}</h5>
          <div style={{ padding: "10px", height: '35px' }} className="text-center">
            {/* {count !== 60 && <Timer options={OPTIONS} />} */}
            {count !== 60 &&
              <span style={{ color: "#0071BC", fontSize: "20px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
              >
                {variable}
              </span>
            }

            {count === 60 &&
              <span
                style={{ color: "#0071BC", fontSize: "20px", fontWeight: "600", textDecoration: "underline", cursor: "pointer" }}
                onClick={resend}
            >{string.resendcode}</span>}
          </div>

          <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: '100%', position: 'relative' }}>
            <Row>
              <PinInput
                length={4}
                focus
                type="numeric"
                onChange={onChange}
              />
              {ErrorFlag&&<p className="ErrorCodestyle">يجب اخال الكود المرسل الى جوالك</p>}
            </Row>
            <button className="btn nextBTN btn-block mb-4" type="submit">{string.nextBTN}</button>
          </form>
        </Modal.Body>
      </Modal>
      {openFormNewPass && <NewPassword close={ToggleForm_newPass} phone={data} />}
    </div >
  );
}

export default ConfirmCode;